/* global app */
'use strict';

import Alerts from 'lib/alerts';
import LoginView from '../views/LogIn.js';
import SignUpView from '../views/SignUp.js';
import ForgotPasswordView from '../views/ForgotPassword.js';
import ChoosePasswordView from '../views/ChoosePassword.js';
import NotificationView from 'commons/views/Notification.js';
import ErrorMobileView from 'commons/views/ErrorMobile.js';
import BaseRouter from 'commons/routers/Base.js';
import modal from 'helpers/modal.js';
import Company from 'newModels/company.js';
import Employee from 'newModels/employee.js';
import Inflect from 'i';
import Log from 'lib/log';
import queryString from 'query-string';
import Employees from 'newCollections/employees.js';
import Holidays from 'newCollections/holidays.js';
import PayrollItems from 'newCollections/payroll-items.js';
import LeaveTypes from 'newCollections/leave-types.js';
import CompanyLocations from 'newCollections/company-locations.js';
import Positions from 'newCollections/positions.js';
import Subscription from 'newModels/subscription.js';
import User from 'newModels/user.js';
const getInviteToken = require('../helpers/getInviteToken');

const inflect = Inflect();
const log = Log('main-router');
const routers = {
    'adminManager': require('adminManager/routers/Main.js'),
    'employer': require('employer/routers/Main.js'),
    'employee': require('employee/routers/Main.js'),
    'mppAdmin': require('mpp/routers/Main.js'),
    'mppManager': require('mpp/routers/Main.js')
};

require('helpers/Numbers');

module.exports = BaseRouter.extend({
    routes: {
        '':                            'index',
        'login':                       'login',
        'loginWithAccessToken?:query': 'loginWithAccessToken',
        'logout':                      'logout',
        'signup':                      'signup',
        'signup?:query':               'signup',
        'signup-page-1':               'signup',
        'signup-page-1-partner':       'signup',
        'signup-page-2':               'signup',
        'signup-page-3':               'signup',
        'signup-page-4':               'signup',
        'signup-page-5':               'signup',
        'signup-page-6':               'signup',
        'signup-page-1?:query':        'signup',
        'signup-page-my-1':            'signup',
        'signup-page-my-1?:query':     'signup',
        'signup/:token':               'signupWithToken',
        'signupMPP/:token':            'signupWithToken',
        'forgotPassword':              'forgotPassword',
        'choosePassword?:query':       'choosePassword',
        'invalidLink':                 'invalidLink',
        'passwordResetSuccess?:query': 'passwordResetSuccess',
        'errorMobile':                 'errorMobile'
    },

    titles: {
        '':                            'Home',
        'login':                       'Login',
        'loginWithAccessToken?:query': 'Login',
        'logout':                      'Logout',
        'signup':                      'Signup',
        'signup-page-1':               'Signup',
        'signup-page-1-partner':       'Signup',
        'signup-page-2':               'Signup',
        'signup-page-my-1':            'Signup',
        'forgotPassword':              'Forgot Password',
        'choosePassword?:query':       'Choose Password',
        'invalidLink':                 'Invalid Link',
        'passwordResetSuccess?:query': 'Password Reset Success',
        'errorMobile':                 'Error',
        'error404':                    'Error',
        'default':                     ''
    },

    guestRoutes: [
        'login',
        'logout',
        'signup',
        'signup-page-1',
        'signup-page-1-partner',
        'signup-page-2',
        'signup-page-3',
        'signup-page-4',
        'signup-page-5',
        'signup-page-6',
        'signup-page-my-1',
        'forgotPassword',
        'choosePassword',
        'invalidLink',
        'passwordResetSuccess',
        'errorMobile',
        'error404'
    ],

    userRouterReady: null,

    initialize: function() {
        log.info('Initializing main router');

        BaseRouter.prototype.initialize.apply(this, [{log: log}]);

        // Save previous fragment
        Backbone.history = _.extend(Backbone.history, {
            loadUrl: function(fragmentOverride) {
                log.info('Storing ', this.fragment, 'as previousFragment');

                this.previousFragment = this.fragment;
                return Backbone.History.prototype.loadUrl
                    .apply(this, [fragmentOverride]);
            }
        });

        if (app.user.isLoggedIn()) {

            this.userRouterReady = new Promise(resolve => {
                this.initializeUserRouter().then(() => resolve(true));
            });

            return;
        }

        log.info('No user present. Skipped user routers');

        log.info('Started history object');
        Backbone.history.start();

        const route = Backbone.history.getFragment().split('?')[0];
        const isValidRoute = this.guestRoutes.indexOf(route) > -1 ||
            !!route.match(/^signup\/[a-zA-Z0-9]+$/g);

        if (!isValidRoute) {
            log.info(route, 'requires authentication. Redirecting to login');
            return this.navigate('login', {trigger: true});
        }
    },

    // guaranteed that after this method run employer users can safely
    // get reference to their company through app.company
    initializeUserRouter: function() {
        let params = queryString.parse(window.location.search);
        let promise = Promise.resolve(false);
        let role = inflect.camelize(app.user.get('role'));
        let Router;

        role = role[0].toLowerCase() + role.slice(1);
        if (app.user.get(`role`) === `super_admin`) {
            role = `adminManager`;
        }

        Router = routers[role];

        log.info('Initializing router for', role, 'user');
        if (app.user.isEmployee()) {
            log.info('Fetching employee');
            promise = app.user.fetchEmployee().then(employee => {
                app.employee = employee;
                return employee.fetchCompany();
            });
        } else if (app.user.get('role') === 'employer') {
            log.info('Fetching company');
            promise = app.user.fetchCompany();
        } else if (app.user.isAdmin()) {
            if (params.company) {
                log.info(`Admin logging into company ${params.company}`);
                Router = routers.employer;
                promise = new Company({objectId: params.company})
                    .fetch({validate: false});
            } else if (params.employee) {
                log.info(`Admin logging in as employee ${params.employee}`);
                Router = routers.employee;
                promise = new Employee({objectId: params.employee})
                    .fetch({validate: false})
                    .then(model => {
                        app.employee = model;
                        return app.employee.fetchUser();
                    })
                    .then(user => {
                        app.user = user;
                        return app.employee.fetchCompany();
                    });
            }
        } else if (app.user.get('role') === 'mpp_admin') {
            if (params.company) {
                log.info(`MPP Admin logging into company ${params.company}`);
                Router  = routers.employer;
                promise = new Company({objectId: params.company})
                    .fetch({validate: false});
            }
        } else if (app.user.get('role') === 'mpp_manager') {
            if (params.company) {
                log.info(`MPP Manager logging into company ${params.company}`);
                Router  = routers.employer;
                promise = new Company({objectId: params.company})
                    .fetch({validate: false});
            }
        }

        return promise.then(company => {
            if (company) {
                log.info(
                    `Fetching payroll items, leave types, locations, \
                    positions, employees from server`
                );

                app.payrollItems = new PayrollItems(null, {company});
                app.leaveTypes = new LeaveTypes(null, {company});
                app.companyLocations = new CompanyLocations(null, {company});
                app.positions = new Positions(null, {company});

                const filter = {filter: {limit: 9999}, pagination: false};
                return Promise.all([
                    app.payrollItems.fetch(),
                    app.leaveTypes.fetch(),
                    app.companyLocations.fetch(),
                    app.positions.fetch(filter)
                ]).then(() => company);
            }

            app.payrollItems = new PayrollItems(null, {});

            if (!app.user.isAdmin()) {
                return company;
            }

            log.info(`Fetching payroll items from server`);

            return app.payrollItems.fetch({filter: {
                where: {
                    companyId: null,
                    hiddenAt: null
                },
                limit: 9999
            }}).then(() => company);
        }).then(company => {
            log.info(`Fetching holidays & employees`);
            if (app.user.get('role') !== 'employee' && company) {
                app.holidays = new Holidays(null, {
                    all: false,
                    enabled: true,
                    company: company,
                    order: '-date'
                });
                app.employees = new Employees(null, {company});
                return Promise.all([
                    app.holidays.fetch(),
                    app.employees.fetch({
                        filter: {limit: 9999},
                        pagination: false
                    })
                ]).then(() => company);
            }

            if (app.user.isEmployee() && app.employee) {
                const locationPromise = app.employee.get('companyLocationId') ?
                    app.employee.fetchCompanyLocation() : Promise.resolve(null);

                app.employees = new Employees([app.employee]);

                return locationPromise.then(location => {
                    app.holidays = new Holidays(null, {
                        all: false,
                        enabled: true,
                        company,
                        location: location && location.id,
                        order: '-date'
                    });
                    return app.holidays.fetch().then(() => company);
                });
            }

            return company;
        }).then(company => {
            log.info('Fetching subscription from server');
            /* Condition to load subscription information is tricky, specially
             * because of the impersonation feature.
             * Basically we load the subscription if any of this conditions
             * are met:
             * 1. You are an admin, or a manager impersonating a company
             * 2. You are an mpp admin looking at the dashboard
             * 2. You are an employer not in the orbit of an mpp admin
             */
            const role = app.user.get('role');
            const fetchSubscription = (
                ['mpp_admin', 'mpp_manager', 'admin_manager', 'super_admin']
                    .includes(role) && company && !app.employee
            ) || (
                role === 'mpp_admin' && !company
            ) || (
                role === 'employer' &&
                company &&
                !company.get('mppAdminId')
            );

            if (fetchSubscription) {
                app.subscription = new Subscription(null, {
                    user: new User({
                        id: !company ? app.user.id : (
                            company.get('mppAdminId') || company.get('userId')
                        )
                    })
                });

                return app.subscription.fetch()
                    .then(() => company)
                    .catch(() => {
                        app.subscription = null;
                        return Alerts.show('error', {
                            text: 'An error ocurred trying to fetch your  ' +
                                'subscription information. You will not be ' +
                                'able to run payrolls until the issue is ' +
                                'resolved. Please try to log back in, and ' +
                                'contact support if the problem persists.'
                        }).then(() => company);
                    });
            }

            return company;
        }).then(company => {
            log.info('Fetched company from server');
            app.company = company;
            app.userRouter = new Router();

            log.info('Starting history object');
            Backbone.history.start();
        }).then(() => {
            if (
                app.user.isEmployer() &&
                app.company &&
                app.company.get('isLocked')
            ) {
                return Alerts.show('error', {
                    text: `Your account has been locked. To unlock your \
                    account please email to us at admin@payrollpanda.my.`,
                    confirmButtonText: 'OK'
                })
                .then(() => {
                    app.userRouter.navigate('logout', {trigger: true});
                });
            }
            if (app.user.isRequirePasswordChange()) {
                return Alerts.show('warning', {
                    text: `We have changed our password policy to optimise \
                    security of PayrollPanda accounts. As a result, you are \
                    required to change your password before you can continue.\
                    Apologies for the inconvenience …. it should only take a\
                    minute!`,
                    confirmButtonText: 'OK'
                })
                .then(() => {
                    app.userRouter.navigate(
                        'personalSettings',
                        {trigger: true}
                    );
                });
            }
        }).catch(err => {
            log.error('Couldn\'t fetch company:', err);

            modal.error({
                text: 'An error ocurred trying to fetch your company ' +
                    'details. Please log back in, if the problem persist ' +
                    'contact support.',
                callback: this.logout.bind(this)
            });
        });
    },

    index: function() {
        let params = queryString.parse(window.location.search);

        if (!app.user.isLoggedIn()) {
            return this.navigate('login', {trigger: true});
        }

        if (!this.userRouterReady) {
            return;
        }

        this.userRouterReady.then(() => {
            if (app.user.isRequirePasswordChange()) {
                return;
            }
            const managerRoles = [
                'admin_manager', 'mpp_admin', 'mpp_manager', 'super_admin'
            ];
            const showCompanyList = (
                managerRoles.includes(app.user.get('role')) &&
                !params.company
            );

            if (showCompanyList) {
                app.userRouter.navigate('companies', {trigger: true});
            } else {
                app.userRouter.navigate('dashboard', {trigger: true});
            }
        });
    },

    login: function() {
        document.title = 'Login HR and Payroll Software | PayrollPanda';
        document.getElementsByName('description')[0].content =
            'Login to PayrollPanda to manage your companies Payroll and ' +
            'Leave. No account yet? Sign up for free and get access to the ' +
            'simplest way to manage your payroll.';
        if (app.user.isLoggedIn()) {
            return this.navigate('', {trigger: true});
        }

        this.view = new LoginView({model: app.user});
    },

    loginWithAccessToken: function (query) {
        if (app.user.isLoggedIn()) {
            return this.navigate('', {trigger: true});
        }
        try {
            const token = JSON.parse(queryString.parse(query).token);
            app.user.setAccessToken(token);
            app.user.set('id', token.userId);
            app.user.fetch()
                .then(() => {
                    app.reload();
                }, err => {
                    modal.error({
                        text: err
                    });
                });
        } catch (e) {
            modal.error({
                text: e
            })
        }
    },

    signup: function(query) {
        if (app.user.isLoggedIn()) {
            return this.navigate('', {trigger: true});
        }

        const params = queryString.parse(window.location.search);
        this.view = new SignUpView({
            query: Object.assign(params, queryString.parse(query)),
            model: app.user
        });
    },

    signupWithToken: function(token) {
        if (app.user.isLoggedIn()) {
            return this.navigate('', {trigger: true});
        }

        getInviteToken(token)
            .then(r => {
                this.view = new SignUpView({
                    record: r,
                    model: app.user
                });
            })
            .catch(err => modal.error({
                title: '',
                text: err
            }));
    },

    forgotPassword: function() {
        if (app.user.isLoggedIn()) {
            return this.navigate('', {trigger: true});
        }

        this.view = new ForgotPasswordView();
    },

    choosePassword: function(query) {
        if (app.user.isLoggedIn()) {
            return this.navigate('', {trigger: true});
        }

        this.view = new ChoosePasswordView({query: query});
    },

    invalidLink: function() {
        this.view = new NotificationView({text: 'Invalid Link'});
    },

    passwordResetSuccess: function() {
        this.view = new NotificationView({
            text: 'Successfully updated your password',
            loginLink: true
        });
    },

    logout: function() {
        let params = queryString.parse(window.location.search);

        if (!app.user.isLoggedIn()) {
            log.info('Trying to logout non existent user. Doing nothing.');
            return;
        }

        if (params.company || params.employee) {
            log.info('Returning to admin dashboard');
            window.location.href = '/';
            return;
        }

        log.info('Performing regular logout.');
        app.user.logout().then(() => {
            log.info('Logged out. Redirecting...');
            window.location.href = '/';
        });
    },

    errorMobile: function() {
        this.view = new ErrorMobileView();
    },

    notFound: function() {
        window.location.replace('/#dashboard');
    }
});



// WEBPACK FOOTER //
// ./app/routers/Main.js